
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpRequest } from "@angular/common/http";
import { catchError, retry } from 'rxjs/operators';
import { throwError, of, Observable } from "rxjs";
import { Injectable } from '@angular/core';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
    providedIn: "root"
})

export class HttpService {
    constructor(private http: HttpClient) {}
    
    progress(url:string) {
        url = url;
        const req = new HttpRequest("GET", url, {
          reportProgress: true  // this is important!
        });
    
        return this.http.request(req);
      }
    createGetRequest(url: string) {
        return this.http.get<any>(url).pipe(catchError(this.handleError));
    }

    createLoginPostRequest(url: any, data: any) {
        return this.http.post<any>(url, data, { observe: 'response' as 'body' }).pipe(catchError(this.handleError));
    }

    createPostRequest(url:string, data: any, orderId:string) {
        url = url + orderId;
        return this.http.post<any>(url, data, httpOptions).pipe(catchError(this.handleError));
    }

    createPutRequest(url: any, data: any, orderId) {
        url = url + orderId;
        return this.http.put<any>(url, data, httpOptions).pipe(catchError(this.handleError));
    }

    createDeleteRequest(url: string, str, id: any, orderId: any) {
        str = str ? str + '/' : '';
        url = url + str + orderId + '/' + id;
        let options = httpOptions;
        return this.http.delete<any>(url, options).pipe(catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof HttpErrorResponse) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            of(error.error);
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(error);
    }
}